// extracted by mini-css-extract-plugin
module.exports = {"footer":"wsYiS","main":"n94qe","content":"I33U9","sidebar":"qPfwA","row":"SjVwd","morphing_borderNone":"piRmH","navigation":"O62SK","addition":"SacXu","block":"BM4q9"};